<template>
  <div class="container2">
    <!-- 加载中 -->
    <div class="loadingMask" v-if="isShowLoading">
      <a-spin tip="请稍等……" />
    </div>
    <div v-else>
      <!-- 新样式添加圆角盒子 -->
      <div
        class="newOrderBox"
        v-if="pageIndex == 1"
        :class="
          onlineSchoolCustomerOrder && onlineSchoolCustomerOrder.length > 0
            ? ''
            : 'whiteBg'
        ">
        <div class="sendBtn">
          <a-button
            v-if="customerDetails.basicCustomerInfo.isHasGitCourse"
            @click="handleGift()">
            赠送课程
          </a-button>
        </div>

        <!-- 订单 -->
        <template
          v-if="
            onlineSchoolCustomerOrder && onlineSchoolCustomerOrder.length > 0
          ">
          <div
            v-for="(item, index) in onlineSchoolCustomerOrder"
            :key="'orderItem' + index"
            class="radiusBoxOrder">
            <!-- <a-divider v-if="index != 0" /> -->
            <div class="formBox2" style="padding-bottom: 0px">
              <!-- <div class="newTitleBox">
              <div class="infoTitle">{{ item.orderNo }}</div>
              <div class="operate">
                <a-button type="link" style="padding: 0; float: right; margin-right: 20px"
                  @click="showOrderDetail(item)">明细</a-button>
              </div>
            </div> -->
              <div class="contentHead">
                <div class="formRow2">
                  <div class="itemTitle">订单编号 :</div>
                  <span>
                    {{ item.orderNo }}
                  </span>
                </div>
                <div class="formRow2">
                  <div class="itemTitle">报名日期 :</div>
                  <span>
                    {{ isEmptyString(item.enrollDate) }}
                  </span>
                </div>
                <div class="formRow2">
                  <div class="itemTitle">班主任 :</div>
                  <span v-if="item.weComHeadTeacherUserName">
                    <span class="teacherName">
                      {{ item.weComHeadTeacherUserName }}</span
                    ><span
                      class="teacherNike"
                      v-if="item.weComHeadTeacherUserNick"
                      >（{{ item.weComHeadTeacherUserNick }}）</span
                    >
                  </span>
                  <span v-else>-</span>
                </div>

                <a-tag
                  class="tag"
                  style="
                    background-color: #ffeded;
                    color: #ff4d4f;
                    border: none;
                  "
                  v-if="item.orderStatus === 2"
                  >未缴清</a-tag
                >
                <a-tag
                  class="tag"
                  style="background-color: #c4c9d3; color: white; border: none"
                  v-if="item.isGiftOrder === 1">
                  赠送课
                </a-tag>
                <a-tag
                  class="tag"
                  style="
                    background-color: #fff5e8;
                    color: #ff9e23;
                    border: none;
                  "
                  v-if="item.orderAuditStatus === 1">
                  待审核
                </a-tag>
                <a-tag
                  class="tag"
                  style="
                    background-color: #ffeded;
                    color: #ff4d4f;
                    border: none;
                  "
                  v-if="item.orderAuditStatus === 3">
                  已驳回
                </a-tag>
                <a-tag
                  class="tag"
                  color="#999999"
                  style="
                    background-color: #f3f4f6;
                    color: #c4c9d3;
                    border: none;
                  "
                  v-if="item.orderAuditStatus === 4">
                  已作废
                </a-tag>
                <a-tag
                  class="tag"
                  color="#999999"
                  style="
                    background-color: #edf1ff;
                    color: #1890ff;
                    border: none;
                  "
                  v-if="item.orderAuditStatus === 5">
                  待领取
                </a-tag>
                <a-tag
                  class="tag"
                  style="
                    background-color: #fff5e8;
                    color: #ff9e23;
                    border: none;
                  "
                  v-if="item.talkStatus === 1">
                  待沟通
                </a-tag>
                <a-tag
                  class="tag"
                  style="
                    background-color: #fff5e8;
                    color: #ff9e23;
                    border: none;
                  "
                  v-if="item.talkStatus === 3">
                  待二次沟通
                </a-tag>
              </div>
              <div class="contentHead">
                <div class="formRow2">
                  <div class="itemTitle">班型名称 :</div>
                  <span>
                    {{ isEmptyString(item.classTypeName) }}
                  </span>
                </div>
                <div class="formRow2">
                  <div class="itemTitle">课程分类 :</div>
                  <span>{{ isEmptyString(item.majorName) }}</span>
                </div>
                <div class="formRow2">
                  <div class="itemTitle">批次名称 :</div>
                  <span>{{ isEmptyString(item.batchName) }}</span>
                </div>
                <div class="formRow2">
                  <div class="itemTitle">班级名称 :</div>
                  <span>
                    {{ isEmptyString(item.orderCourseClassName) }}
                  </span>
                </div>
                <div class="formRow2">
                  <div class="itemTitle">合同状态 :</div>
                  <span
                    v-if="item.contractSignStatus === 2"
                    style="color: #f59a24"
                    >待静默签署</span
                  >
                  <span v-else-if="item.contractSignStatus === 3"
                    >已静默签署</span
                  >
                  <span
                    v-else-if="item.contractSignStatus === 4"
                    style="color: #f59a24"
                    >待实名签署</span
                  >
                  <span v-else-if="item.contractSignStatus === 5"
                    >已实名签署</span
                  >
                  <span v-else>无需签署</span>
                </div>
                <div class="formRow2">
                  <div class="itemTitle">合同主体 :</div>
                  <span>{{ isEmptyString(item.agreementCompanyName) }}</span>
                </div>
                <div class="formRow2">
                  <div class="itemTitle">课程状态 :</div>
                  <span
                    v-if="item.orderCourseStatus === 1"
                    style="color: #f59a24">
                    待开课
                  </span>
                  <span v-if="item.orderCourseStatus === 2"> 已开课 </span>
                  <span v-if="item.orderCourseStatus === 3"> 已转班 </span>
                  <span
                    v-if="item.orderCourseStatus === 4"
                    style="color: #999999">
                    已退课
                  </span>
                  <span
                    v-if="item.orderCourseStatus === 5"
                    style="color: #999999">
                    已停课
                  </span>
                  <span
                    v-if="item.orderCourseStatus === 6"
                    style="color: #999999">
                    退课保留课节
                  </span>
                  <span
                    v-if="item.orderCourseStatus === 7"
                    style="color: #1e57ea">
                    冻结
                  </span>
                </div>
                <!-- <div class="formRow2">
                  <div class="itemTitle">学习状态 :</div>
                  <span v-if="item.orderCourseLearnStatus === 1">正常学习</span>
                  <span
                    v-if="item.orderCourseLearnStatus === 2"
                    style="color: red"
                    >欠费停课</span
                  >
                  <span
                    v-if="item.orderCourseLearnStatus === 3"
                    style="color: #faad14"
                    >暂停学习</span
                  >
                </div> -->
              </div>
              <!-- 新共计盒子 -->
              <div class="computeBox">
                <div class="computeItem">
                  <div>共计</div>
                  <div
                    :style="{
                      color: Number(dealAmountM(item)) == 0 ? '' : '#faad14',
                    }">
                    {{ dealAmountM(item) }}
                  </div>
                  <!-- <div>￥19999.99</div> -->
                </div>
                <div class="computeItem">
                  <div>已缴</div>
                  <div
                    :style="{
                      color: paidAmountM(item) == 0 ? '' : '#52c41a',
                    }">
                    {{ paidAmountM(item) }}
                  </div>
                  <!-- <div>￥19999.99</div> -->
                </div>
                <div class="computeItem">
                  <div>欠款</div>
                  <div
                    :style="{
                      color: item.oweAmount === 0 ? '' : '#f5222d',
                    }">
                    {{ item.oweAmount }}
                  </div>
                  <!-- <div>￥19999.99</div> -->
                </div>
                <div class="computeItem">
                  <div>多缴</div>
                  <div
                    :style="{
                      color: item.morePayAmountTotal === 0 ? '' : '#5bc0de',
                    }">
                    {{ item.morePayAmountTotal }}
                  </div>
                  <!-- <div>￥19999.99</div> -->
                </div>
                <a-button size="small" @click="showOrderDetail(item)">
                  详情
                </a-button>
              </div>
              <div class="historyOrderCourseList">
                <a-table
                  v-if="
                    item.historyOrderCourseList &&
                    item.historyOrderCourseList.length > 0
                  "
                  :columns="columns"
                  :data-source="item.historyOrderCourseList"
                  bordered
                  :showHeader="false"
                  :pagination="false"
                  class="tableLog"
                  :rowKey="
                    (record, index) => {
                      return index;
                    }
                  "
                  size="small">
                  <template slot="title" slot-scope="currentPageData">
                    该订单历史发生过转班，历史课程记录：
                  </template>
                </a-table>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="emptyBox">暂无订单</div>
        </template>
      </div>
      <!-- 订单详情页面 -->
      <paymentDetail
        v-else-if="pageIndex == 2"
        ref="paymentDetail"
        @handleBack="giftHandleBack"></paymentDetail>
      <!-- 赠送课页面 -->
      <giftList
        :externalCustomerId="externalUserId"
        :userInfo="userInfo"
        ref="giftList"
        @handleBack="giftHandleBack"
        v-else-if="pageIndex == 3">
      </giftList>
    </div>
  </div>
</template>

<script>
import {
  queryOnlineSchoolCustomerOrder,
  selectPayWayDetailsByOrderId,
  queryGiftCourseUserAuthority,
} from "@/api/detail";
import { moneyFormat } from "@/filters";
import store from "@/store";
import giftList from "@/views/components/giftList.vue";
import paymentDetail from "@/views/components/paymentDetail.vue";

export default {
  name: "orderInfo",
  props: {
    externalUserId: {
      type: String,
      default: "",
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
    customerDetails: {
      type: Object,
      default: () => {},
    },
  },
  filters: { moneyFormat },
  components: { giftList, paymentDetail },
  data() {
    return {
      onlineSchoolCustomerOrder: [],
      isShowLoading: false,
      isShowOrderDetail: false,
      isShowNoOrderDetail: false,
      orderDetailList: [],
      payStatusOptions: {
        1: "待支付",
        2: "已支付",
        3: "缴费中",
        4: "已失效",
      },
      pageIndex: 1, //1:订单页；2:详情页；3:赠送课程页
    };
  },
  computed: {},
  async created() {
    this.init();
  },
  methods: {
    init() {
      this.isShowLoading = true;
      this.queryOnlineSchoolCustomerOrderM();
      this.isShowLoading = false;
    },
    queryOnlineSchoolCustomerOrderM() {
      return new Promise(async (resolve, reject) => {
        let corpId = store.getters.corpId;
        const { result } = await queryOnlineSchoolCustomerOrder({
          corpId: corpId,
          externalUserId: this.externalUserId,
          tenantId: store.getters.tenantId,
        });
        this.onlineSchoolCustomerOrder = result;
        resolve();
      });
    },
    // 总计
    dealAmountM(item) {
      // 总计=成交总额+总扣款金额
      let dealAmount =
        (Number(item.dealAmount) || 0) +
        (Number(item.totalDeductionAmount) || 0);
      return dealAmount;
    },
    // 已缴
    paidAmountM(item) {
      // 已缴=总计-欠款金额+多缴金额
      // let dealAmount =
      //   (Number(item.dealAmount) || 0) +
      //   (Number(item.totalDeductionAmount) || 0);
      // let paidAmount =
      //   (Number(dealAmount) || 0) - (Number(item.oweAmount) || 0) + (Number(item.morePayAmountTotal) || 0);
      // return paidAmount;

      return item.paidAmount;
    },
    // 显示订单明细弹窗
    async showOrderDetail(item = 0) {
      if (item) {
        // if (!this.payStatusOptions) await this.getDictOptions();
        let { result } = await selectPayWayDetailsByOrderId({
          orderId: item.orderId,
          tenantId: store.getters.tenantId,
        });
        this.orderDetailList = result;
      }

      console.log("传之前获取参数", this.customerDetails, this.orderDetailList);

      // 跳转到 '/new-path' 并附带查询参数
      sessionStorage.setItem(
        "customerDetails",
        JSON.stringify(this.customerDetails)
      );
      // let params = {
      //   path: "/detail",
      //   query: {
      //     order: this.orderDetailList,
      //     userId: this.userInfo.userId,
      //     externalCustomerId: this.externalUserId,
      //     corpId: store.getters.corpId,
      //   },
      // };
      // params.query.type = item ? "order" : "userInfo";

      let data = {
        order: this.orderDetailList,
        userId: this.userInfo.userId,
        externalCustomerId: this.externalUserId,
        corpId: store.getters.corpId,
        type: item ? "order" : "userInfo",
        orderNo: item.orderNo,
      };
      this.pageIndex = 2;
      this.$nextTick(() => {
        this.$refs.paymentDetail.init(data);
      });
      // this.$router.push(params);
    },
    handleGift() {
      const params = {
        corpId: store.getters.corpId,
        wechatUserId: this.userInfo.userId,
        tenantId: store.getters.tenantId,
      };
      queryGiftCourseUserAuthority(params).then((res) => {
        if (res.code == 200) {
          this.pageIndex = 3;
          this.$nextTick(() => {
            this.$refs.giftList.init();
          });
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    giftHandleBack() {
      this.init();
      this.pageIndex = 1;
    },
    isEmptyString(str) {
      if (str) {
        if (str.trim().length != 0) {
          return str;
        } else {
          return "-";
        }
      } else {
        return "-";
      }
    },
  },
  mounted() {},
};
</script>

<style lang="less" scope>
.tag {
  margin: 10px 10px 10px 10px;
}
.container2 {
  // background-color: #8ec3ff;
  height: 95vh;
  // overflow: scroll;
  // box-sizing: border-box;
  // padding-top: 10px;
}
.sendBtn {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 0 10px 10px 0;
}
.course_tag {
  margin-left: 20px;
  margin-top: 10px !important;
}
.newOrderBox {
  padding-top: 10px;
  background: linear-gradient(to bottom, #1a90fe 0%, #8ec3ff 100%);
  height: 95vh;
  overflow: scroll;
  &:last-child {
    padding-bottom: 2%;
  }

  .historyOrderCourseList {
    padding: 0 20px 16px 20px;
  }
}
.whiteBg {
  background: white !important;
}

// 新增订单信息圆角样式
.radiusBoxOrder {
  width: 96% !important;
  border-radius: 10px;
  margin: 0 2% 5% 2%;
  // padding: 2% 0;
  background-color: white;
  padding: 5px 0;
}

.outsideTitle {
  height: 30px;
  font-size: 16px;
  font-weight: 700;
  // padding-left: 40px;
  line-height: 40px;

  .title {
    color: #333333;
    position: relative;
    padding-left: 25px;
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    margin-top: 10px;

    &::before {
      content: "";
      position: absolute;
      left: 10px;
      top: 0;
      width: 4px;
      height: 100%;

      // background: #1890ff;
      background: linear-gradient(180deg, #1a90fe 0%, #74b2eb 100%);
    }
  }
}

.paddbox {
  padding-bottom: 20px;
}

.nullBox {
  color: #ccc;
  height: 150px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .txt {
    width: 190px;
    text-align: center;
  }
}

.totalBox {
  background: rgb(242, 242, 242);
  border: 1px solid rgb(215, 215, 215);
  padding: 4px 4px;
  box-sizing: border-box;
  margin-top: 4px;
  font-size: 12px;
}

.tableLog {
  margin-top: 10px;

  .ant-table-title,
  td {
    padding: 10px 4px;
  }
}

.teacherName {
  display: inline-block;
  // white-space: normal;
  // float: left;
}

.teacherNike {
  color: #8080ff;
  display: inline-block;
  // white-space: normal;
  // padding-left: 1px;
  // float: left;
}
.contentHead {
  border-bottom: #d6d1d1 1px solid;
  .formRow2 {
    // 统一设置字体为14px
    font-size: 14px !important;
    margin-top: 4px;
    display: flex;
    flex-direction: row;
    line-height: 20px;
    height: 20px;
    > label {
      display: inline-block;
      // width: 120px;
      width: 120px !important;
      flex-shrink: 0;
      // color: rgba(0, 0, 0, 0.85);
      color: #666666;
      text-align: right;
      // text-align: left;
      margin-right: 10px;
    }
    > span {
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      flex-shrink: 1;
      white-space: nowrap;
      // color: rgba(0, 0, 0, 0.65);
      color: #111111;
      // text-align: right;
    }
    .itemTitle {
      height: 30px;
      width: 100px !important;
      text-align: right;
      margin-right: 10px;
    }
  }
}
.computeBox {
  margin-top: 10px;
  display: flex;
  font-size: 12px;
  justify-content: space-around;
  align-items: center;
  .computeItem {
    // background-color: #1a90fe;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    width: 50px;
  }
}
.emptyBox {
  width: 96% !important;
  height: 100px;
  border-radius: 10px;
  margin: 0 2% 5% 2%;
  background-color: white;
  padding: 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 1px solid rgb(215, 215, 215);
}
</style>
